

import { useAsObservableSource } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { observer } from 'src/utils/mobx-react';
import { AvailableOnState } from './AvailableOn.state';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';

interface AvailableOnPropsTypes {
    eventId: EventId
}

export const AvailableOn = observer('AvailableOn', (propsIn: AvailableOnPropsTypes) => {
    const props = useAsObservableSource(propsIn);
    const { eventStateActions, sdkStaff } = useAppStateContext();
    const [timeEventSettingsState] = useState(() => new AvailableOnState(() => props.eventId, sdkStaff, eventStateActions));

    const {
        isLoadingEventUpdate,
        antePost, onChangeAntePost
    } = timeEventSettingsState;

    return (
        <section className={'event-details-box last' /*  disabled: !event.getIn([ 'feedData', 'feedId' ]) } */}>
            <h4>Available on (API needed) <span style={{ fontSize: '10px' }}>{isLoadingEventUpdate ? 'Making changes, wait...' : null}</span></h4>
            <div>
                <div className='row'>
                    <div className='col-6'>
                        <div className={'element checkbox'} data-test='ante-post-checkbox'>
                            <label>
                                <input
                                    type='checkbox'
                                    checked={antePost}
                                    onChange={onChangeAntePost}
                                />
                                <span>Ante-post</span>
                            </label>
                        </div>
                    </div>
                </div>
                <span style={{ fontSize: '10px', fontWeight: 300, color: '#888' }}>Waiting for API (disabled):</span>
                <div className='row'>
                    <div className='col-6'>
                        <div className={'element checkbox'}>
                            <label>
                                <input
                                    type='checkbox'
                                    checked={false}
                                    onChange={(): void => {
                                        console.log('TODO - create api for Available on Internet');
                                    }}
                                />
                                <span>Internet</span>
                            </label>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className={'element checkbox'}>
                            <label>
                                <input
                                    type='checkbox'
                                    checked={false}
                                    onChange={(): void => {
                                        console.log('TODO - create api for Available on Retail');
                                    }}
                                />
                                <span>Retail</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-6'>
                        <div className={'element checkbox'}>
                            <label>
                                <input
                                    type='checkbox'
                                    checked={false}
                                    onChange={(): void => {
                                        console.log('TODO - create api for Available on Tele-betting');
                                    }}
                                />
                                <span>Tele-betting</span>
                            </label>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className={'element checkbox'}>
                            <label>
                                <input
                                    type='checkbox'
                                    checked={false}
                                    onChange={(): void => {
                                        console.log('TODO - create api for Available on Mobile');
                                    }}
                                />
                                <span>Mobile</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
});
